/**
 * Whether the notifications modal opens (HomeView). MYAC-1522 (onboarding pass,
 * decision C): one ask at a time — never while « Faisons connaissance » still has
 * questions (on 09/10 the modal covered them, and the more administrative ask won).
 */
export function shouldShowNotificationSetup(opts: {
  setupDone: boolean
  projectCount: number
  projectsLoaded: boolean
  /** The company-creation session: it re-prompts on the next visit. */
  skippedThisSession: boolean
  onboardingStepsMissing: number
  /** QMS and products of the company: what assessment emails are about. */
  assessmentProjectCount: number
  /** The watch report was asked in the welcome letter (`watch_report_asked`). */
  watchReportAsked: boolean
}): boolean {
  // A watch-only company asked about its report in the letter has nothing left to set.
  if (opts.assessmentProjectCount === 0 && opts.watchReportAsked) return false
  return !opts.setupDone
    && opts.projectsLoaded
    && opts.projectCount > 0
    && !opts.skippedThisSession
    && opts.onboardingStepsMissing === 0
}
